var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"large":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[(_vm.type === 'classroom')?_c('div',[_vm._v("Stofa: "+_vm._s(_vm.item.stofa_eink)+" "+_vm._s(_vm.item.stofa_heiti))]):_vm._e()]),_c('br'),_c('Timetable',{attrs:{"id":_vm.id,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }